module.exports = __webpack_public_path__ + "img/japanese-“prohibited”-button.5970956e.png";